import _isString from 'lodash.isstring';

export function isString(value: any): value is string {
  return _isString(value);
}
